/** Board geometry. Standard Connect Four is 6 rows x 7 columns, 4-in-a-row to win. */
export const ROWS = 6;
export const COLS = 7;
export const CONNECT = 4;

/** A disc belonging to a player. 1 = first player, 2 = second player. */
export type Disc = 1 | 2;

/** A board cell: 0 = empty, otherwise the disc occupying it. */
export type Cell = 0 | Disc;

/**
 * The grid, indexed as `board[row][col]`.
 * Row 0 is the TOP row; row ROWS-1 is the BOTTOM row (the floor).
 * Discs fall to the highest available row index in a column ("gravity").
 */
export type Board = Cell[][];

export type GameStatus = 'playing' | 'won' | 'draw';

export interface Coord {
  row: number;
  col: number;
}

export interface GameState {
  board: Board;
  /** Whose turn it is. Only meaningful when status === 'playing'. */
  currentPlayer: Disc;
  status: GameStatus;
  /** The winning disc when status === 'won', otherwise null. */
  winner: Disc | null;
  /** The cells forming the winning line, for UI highlighting. Null unless won. */
  winningLine: Coord[] | null;
  /** Total discs played so far. */
  moveCount: number;
}

/** Returns the other player's disc. */
export function opponent(disc: Disc): Disc {
  return disc === 1 ? 2 : 1;
}
